export default {
  props: {
    // 内容为空的时候展示的文本
    emptyText: {
      default: "暂无数据"
    },
    // 展示数据
    data: {
      default: () => []
    },
    // 每个树节点用来作为唯一标识的属性，整棵树应该是唯一的
    nodeKey: {
      default: "id"
    },
    // 属性配置
    props: {
      default: () => ({
        // 指定节点标签为节点对象的某个属性值,string, function(data, node)
        label: "label",
        // 指定子树为节点对象的某个属性值
        children: "children",
        // 指定节点选择框是否禁用为节点对象的某个属性值, boolean, function(data, node)
        disabled: "disabled",
        // 指定节点是否为叶子节点，仅在指定了 lazy 属性的情况下生效	boolean, function(data, node)
        isLeaf: "leaf",
        // 指定节点显示checkbox框 boolean, function(data, node)
        showCheckbox: "showCheckbox",
        // 指定节点自定义class名 string, function(data, node)
        customClass: null
      })
    },
    // 节点高度
    nodeHeight: {
      default: 26
    },
    // 是否默认展开所有节点
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    // 默认展开级别
    defaultExpandLevel: {
      type: Number,
      default: 1
    },
    // 每层缩进
    levelIndentWidth: {
      default: 20
    },
    /**
     * 是否在点击节点的时候展开或者收缩节点
     * 默认值为 true，如果为 false，则只有点箭头图标的时候才会展开或者收缩节点
     */
    expandOnClickNode: {
      type: Boolean,
      default: true
    },
    /**
     * 是否在点击节点的时候选中节点
     * 默认值为 false，即只有在点击复选框时才会选中节点
     */
    checkOnClickNode: {
      type: Boolean,
      default: false
    },
    // 展开子节点的时候是否自动展开父节点
    autoExpandParent: {
      type: Boolean,
      default: true
    },
    // 默认勾选的节点的 key 的数组
    defaultCheckedKeys: {
      default: null
    },
    // 默认展开的节点的 key 的数组
    defaultExpandedKeys: {
      default: () => []
    },
    // 节点是否可被选择
    showCheckbox: {
      type: Boolean,
      default: false
    },
    // 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法，默认为 false
    checkStrictly: {
      type: Boolean,
      default: false
    },
    // 是否每次只打开一个同级树节点展开
    accordion: {
      type: Boolean,
      default: false
    },
    // 当前选中的节点
    currentNodeKey: {
      default: null
    },
    // 是否高亮当前选中节点，默认值是 false
    highlightCurrent: {
      type: Boolean,
      default: false
    },
    // 是否懒加载子节点，需与 load 方法结合使用
    lazy: {
      type: Boolean,
      default: false
    },
    // 加载子树数据的方法，仅当 lazy 属性为true 时生效
    load: {
      default: null
    },
    /**
     * 对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示，返回 false 则表示这个节点会被隐藏
     */
    filterNodeMethod: {
      default: null
    },
    /**
     * 是否开启拖拽节点功能
     */
    draggable: {
      type: Boolean,
      default: false
    },
    /**
     * 搜索模式
     * lazy 远程
     */
    filterType: {
      default: ""
    }
  },
  data() {
    return {
      dragstart: false,
      isInit: false,
      showHeight: 0,
      scrollY: 0,
      maxHeight: 0,
      showNodes: [],
      totalData: 0,
      currentNode: null,
      filterText: null,
      nodeTree: this.getRootNode()
    };
  },
  computed: {
    _defaultExpandedKeys() {
      let set = new Set();
      let keys = this.defaultExpandedKeys || [];
      keys.forEach((it) => {
        set.add(it);
      });
      return set;
    },
    _defaultCheckedKeys() {
      let set = new Set();
      let keys = this.defaultCheckedKeys || [];
      keys.forEach((it) => {
        set.add(it);
      });
      return set;
    },
    existNodeKey() {
      return !dsf.isUnDef(this.nodeKey);
    },
    isLeafKey() {
      return this?.props?.isLeaf;
    },
    childrenKey() {
      return this.props?.children || "children";
    },
    labelKey() {
      return this.props?.label || "label";
    },
    nodeData() {
      return this?.nodeTree?.childNodes || [];
    }
  },
  methods: {
    /**
     * 自定义node-class
     * @param {*} node
     */
    customNodeClass(node) {
      let customClass = this?.props?.customClass;
      if (dsf.isFunction(customClass)) {
        return customClass(node.data, node);
      }
      return customClass || null;
    },
    /**
     * 是否显示复选框
     * @param {*} node
     */
    isShowCheckbox(node) {
      let showCheckboxKey = this?.props?.showCheckbox;
      if (!this.showCheckbox) {
        return false;
      }
      if (dsf.isFunction(showCheckboxKey)) {
        return showCheckboxKey(node.data, node);
      } else if (dsf.isString(showCheckboxKey)) {
        return node?.data?.[showCheckboxKey] !== false;
      }
      return this.showCheckbox;
    },
    /**
     * 开始拖拽
     * @param {*} ev
     * @param {*} node
     */
    dragStart(ev, node) {
      this.dragNode = node;
      this.dragstart = true;
    },
    /**
     * 拖拽结束
     * @param {*} ev
     * @param {*} node
     */
    dragEnd(ev, node) {
      this.dragstart = false;
    },
    /**
     * 拖拽滑动到可放置
     * @param {*} ev
     * @param {*} node
     */
    dragOver(ev, node) {
      ev.preventDefault();
      let offsetY = ev.offsetY;
      if (this.oldOffsetY == offsetY) return;
      this.oldOffsetY = offsetY;
      let target = ev.target;
      let dropNodeId = target.getAttribute("node-id");
      let oldDropNodeId = this?.dropNode?.id;
      if (oldDropNodeId != dropNodeId) {
        if (oldDropNodeId) {
          $(this.$el)
            .find(`.ds-virtual-tree-node[node-id=${oldDropNodeId}]`)
            .removeAttr("drop-over-type");
        }
        this.dropNode = this.nodeMap[dropNodeId];
        this.dropNodeHeight = target.clientHeight || this.nodeHeight;
      }
      this.dropOverType = "in";
      if (offsetY < 5) {
        this.dropOverType = "before";
      } else if (offsetY > this.dropNodeHeight - 5) {
        this.dropOverType = "after";
      }
      target.setAttribute("drop-over-type", this.dropOverType);
    },
    /**
     * 放置
     * @param {*} ev
     * @param {*} node
     */
    drop(ev, node) {
      this.dragstart = false;
      if (node.id == this.dragNode.id) {
        return;
      }
      if (this.dropOverType == "in") {
        this.append(this.dragNode, node);
      } else if (this.dropOverType == "before") {
        this.insertBefore(this.dragNode, node);
      } else if (this.dropOverType == "after") {
        this.insertAfter(this.dragNode, node);
      }
      if (node.id) {
        $(this.$el).find(`.ds-virtual-tree-node[node-id=${node.id}]`).removeAttr("drop-over-type");
      }
    },
    /**
     * 节点双击
     * @param {*} node
     * @param {*} evt
     */
    dblclickNode(node, evt) {
      this.$emit("node-dblclick", evt, node.data, node);
    },
    /**
     * 节点右键
     * @param {*} node
     * @param {*} evt
     */
    contextmenuNode(node, evt) {
      this.$emit("node-contextmenu", evt, node.data, node);
    },
    /**
     * 节点点击
     * @param {*} node
     * @param {*} evt
     */
    clickNode(node, evt) {
      if (this.checkOnClickNode && !this.isDisabledNode(node)) {
        this.checkboxClick(node, !node.checked);
      }
      if (this.expandOnClickNode) {
        this.expandNode(node, !node.expanded);
      }
      if (this.highlightCurrent) {
        this.setCurrentNode(node);
      }
      this.$emit("node-click", node.data, node);
    },
    /**
     * 点击节点复选框
     * @param {*} node
     * @param {*} $event
     */
    checkboxClick(node, $event) {
      this.checkNode(node, $event);
      if (this.$listeners?.check) {
        let checkedNodes = this.getCheckedNodes();
        let halfCheckedNodes = this.getHalfCheckedNodes();
        this.$emit("check", node.data, {
          checkedNodes: checkedNodes,
          checkedKeys: checkedNodes.map((t) => this.getNodeDataKey(t)),
          halfCheckedKeys: halfCheckedNodes,
          halfCheckedNodes: halfCheckedNodes.map((t) => this.getNodeDataKey(t))
        });
      }
    },
    /**
     * 展开节点
     * @param {*} node 节点
     * @param {*} expanded // 展开状态
     * @param {*} expandedAllChildren // 是否展开所有子节点
     */
    expandNode(node, expanded, expandedAllChildren) {
      if (this.isExpandedOpacity(node)) return;
      if (this.lazy && !node.loading && !node.loaded) {
        this.loadData(node, () => {
          this._expandNode(node, expanded, expandedAllChildren);
        });
      } else {
        this._expandNode(node, expanded, expandedAllChildren);
      }
    },
    /**
     * 展开节点 内部函数
     * @param {*} node 节点
     * @param {*} expanded // 展开状态
     * @param {*} expandedAllChildren // 是否展开所有子节点
     */
    _expandNode(node, expanded, expandedAllChildren) {
      const isExpandedChange = node.expanded != expanded;
      node.expanded = expanded;
      if (expanded && this.autoExpandParent && node.parent) {
        this.expandNode(node.parent, expanded, false);
      }
      if (expanded && this.accordion) {
        let childNodes = node.parent?.childNodes || this.nodeData;
        childNodes?.forEach((cNode) => (cNode.expanded = false));
      }
      if (expandedAllChildren) {
        let childNodes = node.childNodes;
        childNodes?.forEach((cNode) => this.expandNode(cNode, expanded, expandedAllChildren));
      }
      if (isExpandedChange) {
        this.updateMaxHeight();
        if (expanded) {
          this.$emit("node-expand", node.data, node);
        } else {
          this.$emit("node-collapse", node.data, node);
        }
      } else {
        this.updateShowNodes();
      }
    },
    /**
     * 设置节点选中状态
     * @param {*} node
     * @param {*} val
     * @param {*} updateParentIndeterminate
     */
    checkNode(node, val, updateParentIndeterminate = true, deep = false) {
      if (!this.existNodeKey || !node || this.isDisabledNode(node)) {
        return;
      }
      const isChange = node.checked != val;
      node.checked = val;
      this.setIndeterminateNode(node, false);
      if (!this.checkStrictly) {
        if (updateParentIndeterminate && node.parent) {
          this.updateParentCheckSatus(node.parent, val);
        }
      }
      if ((!this.checkStrictly || deep) && node.childNodes?.length) {
        node.childNodes.forEach((cNode) => {
          this.checkNode(cNode, val, false, true);
        });
      }
      isChange && !node.isRoot && this.$emit("check-change", node.data, node.checked, node);
    },
    /**
     * 通过 key / data 设置某个节点的勾选状态，使用此方法必须设置 node-key 属性
     * @param {String|Object} key 勾选节点的 key 或者 data
     * @param {Boolean} checked 节点是否选中
     * @param {Boolean} deep 是否只设置子节点 ，默认为 false
     * @param {Boolean} isRepeatKey 是否设置重复的key
     */
    setChecked(key, checked, deep = false, isRepeatKey = false) {
      let nodes = [];
      if (isRepeatKey) {
        nodes = this.keysGetNodes(key, isRepeatKey).filter((t) => !!t);
      } else {
        nodes = [this.getNode(key)];
      }
      nodes.forEach((node) => {
        this.checkNode(node, checked, true, deep);
      });
    },
    /**
     * 通过 key 设置某个节点的当前选中状态，使用此方法必须设置 node-key 属性
     * @param {String} key 待被选节点的 key，若为 null 则取消当前高亮的节点
     */
    setCurrentKey(key) {
      if (!this.existNodeKey) {
        return;
      }
      this.setCurrentNode(this.getNode(key));
    },
    /**
     * 通过 node 设置某个节点的当前选中状态，使用此方法必须设置 node-key 属性
     * @param {*} node 待被选节点的 node
     */
    setCurrentNode(node) {
      if (!this.existNodeKey) {
        return;
      }
      if (this.currentNode) {
        this.currentNode.isCurrent = false;
      }
      if (node) {
        node.isCurrent = true;
      }
      this.currentNode = node;
    },
    /**
     * 获取当前被选中节点的 key，使用此方法必须设置 node-key 属性，若没有节点被选中则返回 null
     */
    getCurrentKey() {
      if (!this.existNodeKey) {
        return null;
      }
      return this.getNodeKey(this?.currentNode);
    },
    /**
     * 获取当前被选中节点的 data，若没有节点被选中则返回 null
     */
    getCurrentNode() {
      if (!this.existNodeKey) {
        return null;
      }
      return this?.currentNode;
    },
    /**
     * 若节点可被选择（即 show-checkbox 为 true），则返回目前被选中的节点所组成的数组
     * @param  {Boolean} leafOnly 是否只是叶子节点，默认值为 false
     * @param  {Boolean} includeHalfChecked 是否包含半选节点，默认值为 false
     * @returns {Array}
     */
    getCheckedNodes(leafOnly = false, includeHalfChecked = false) {
      let checkedNodes = [];
      this.nodeDataDeepForEach((node, ev) => {
        if (includeHalfChecked && node.indeterminate) {
          checkedNodes.push(node?.data);
          ev.continue();
        }
        if (node.checked) {
          if (leafOnly && !node.isLeaf) ev.continue();
          checkedNodes.push(node?.data);
        }
      });
      return checkedNodes;
    },
    /**
     * 若节点可被选择（即 show-checkbox 为 true），则返回目前被选中的节点所组成的数组
     * @param  {Boolean} leafOnly 是否只是叶子节点，默认值为 false
     * @param  {Boolean} includeHalfChecked 是否包含半选节点，默认值为 false
     * @param {Boolean} uniqBy 去除重复key
     * @returns {Array}
     */
    getCheckedKeys(leafOnly = false, includeHalfChecked = false, uniqBy = true) {
      let checkedNodes = this.getCheckedNodes(leafOnly, includeHalfChecked);
      let checkedKeys = checkedNodes.map((node) => this.getNodeDataKey(node));
      return uniqBy ? _.uniqBy(checkedKeys) : checkedKeys;
    },
    /**
     * 设置目前勾选的节点，使用此方法必须设置 node-key 属性
     * @param {Array} nodes 接收勾选节点数据的数组
     * @param {Boolean} isCheckLeaf 若为 true 则仅设置叶子节点的选中状态，默认值为 false
     */
    setCheckedNodes(nodes, isCheckLeaf) {
      if (nodes && !dsf.isArray(nodes)) nodes = [nodes];
      nodes = nodes.map((t) => this.getNode(t)).filter((t) => !!t);
      let nodeData = [...this.nodeData];
      while (nodeData.length) {
        let node = nodeData.shift();
        let isBreak = false;
        if (nodes.findIndex((n) => n?.id == node.id) >= 0) {
          if (this.checkStrictly) {
            this.checkNode(node, true, false);
          } else if (isCheckLeaf) {
            isBreak = true;
            if (node.checked) this.checkNode(node, false);
            this.setCheckedNodeIsLeaf(node);
          } else {
            isBreak = true;
            this.checkNode(node, true, true, true);
          }
        } else {
          if (node.checked) this.checkNode(node, false);
        }
        if (!isBreak && node?.childNodes?.length) {
          nodeData.push(...node.childNodes);
        }
      }
    },
    /**
     * 设置节点是否是叶子
     * @param {*} node
     */
    setCheckedNodeIsLeaf(node) {
      let nodeData = [node];
      while (nodeData.length) {
        let node = nodeData.shift();
        if (node.isLeaf) {
          this.checkNode(node, true, false, false);
        }
        if (node?.childNodes?.length) {
          nodeData.push(...node.childNodes);
        }
      }
    },
    /**
     * 设置目前勾选的节点Key，使用此方法必须设置 node-key 属性
     * @param {Array} keys 接收勾选节点数据的数组
     * @param {Boolean} isCheckLeaf 若为 true 则仅设置叶子节点的选中状态，默认值为 false
     * @param {Boolean} isRepeatKey
     */
    setCheckedKeys(keys, isCheckLeaf, isRepeatKey = false) {
      if (keys && !dsf.isArray(keys)) keys = [keys];
      this.setCheckedNodes(
        this.keysGetNodes(keys, isRepeatKey).filter((t) => !!t),
        isCheckLeaf
      );
    },
    /**
     * 通过 keys获取节点
     */
    keysGetNodes(keys, isRepeatKey = false) {
      if (!dsf.isArray(keys)) keys = [keys];
      let nodes = [];
      if (isRepeatKey) {
        keys.forEach((key) => {
          let node = this.getNode(key, true);
          if (dsf.isArray(node)) {
            nodes.push(...node);
          } else {
            nodes.push(node);
          }
        });
      } else {
        nodes = keys.map((t) => this.getNode(t));
      }
      return nodes;
    },
    /**
     * 若节点可被选择（即 show-checkbox 为 true）
     * @returns {Array}返回目前半选中的节点所组成的数组
     */
    getHalfCheckedNodes() {
      let halfCheckedNodes = [];
      this.nodeDataDeepForEach((node) => {
        if (node.indeterminate) {
          halfCheckedNodes.push(node?.data);
        }
      });
      return halfCheckedNodes;
    },
    /**
     * 若节点可被选择（即 show-checkbox 为 true）
     * @param {Boolean} uniqBy 是否去重key
     * @returns {Array}返回目前半选中的节点所组成的数组
     */
    getHalfCheckedKeys(uniqBy = false) {
      let halfCheckedKeys =
        this.getHalfCheckedNodes()?.map((node) => this.getNodeDataKey(node)) || [];
      return uniqBy ? _.uniqBy(halfCheckedKeys) : halfCheckedKeys;
    },
    /**
     * 更新父节点的选中和半选状态
     * @param {*} pNode
     * @param {*} val 子节点触发选中的状态，不传认为是节点移动操作
     */
    updateParentCheckSatus(pNode, val) {
      if (!pNode) return;
      let { isAllChecked, isAllNotChecked, indeterminate } = this.getIsIndeterminate(
        pNode?.childNodes
      );
      if (indeterminate) {
        this.setIndeterminateNode(pNode, true);
      } else {
        if (val === undefined) {
          if (isAllChecked) {
            val = true;
          } else if (isAllNotChecked) {
            val = false;
          }
        }
        this.checkNode(pNode, val, true);
      }
    },
    /**
     * 检查节点列表是否是半选
     * @param {*} nodeList
     * @returns
     */
    getIsIndeterminate(nodeList) {
      let isAllChecked = true;
      let isAllNotChecked = true;
      let indeterminate = false;
      let childNodes = nodeList;
      if (childNodes?.length) {
        for (let i = 0; i < childNodes.length; i++) {
          if (childNodes[i].indeterminate) {
            indeterminate = true;
            break;
          }
          if (!childNodes[i].checked) {
            isAllChecked = false;
          } else {
            isAllNotChecked = false;
          }
          if (!isAllChecked && !isAllNotChecked) {
            indeterminate = true;
            break;
          }
        }
      }
      return {
        isAllChecked,
        isAllNotChecked,
        indeterminate
      };
    },
    /**
     * 半选节点
     * @param {*} node
     * @param {*} val
     */
    setIndeterminateNode(node, val) {
      node.indeterminate = val;
      if (val) {
        node.checked = false;
        if (node.parent) {
          this.setIndeterminateNode(node.parent, val);
        }
      }
    },
    /**
     * 循环所有节点
     * @param {*} cb
     */
    nodeDataDeepForEach(cb, nodeList) {
      let nodeData = [...(nodeList || this.nodeData)];
      while (nodeData.length) {
        let node = nodeData.shift();
        let isContinue = false;
        let isBreak = false;
        cb?.(node, {
          continue: () => {
            isContinue = true;
          },
          break: () => {
            isBreak = true;
          }
        });
        if (isBreak) {
          break;
        }
        if (isContinue) {
          continue;
        }
        if (node.childNodes?.length) {
          nodeData.unshift(...node.childNodes);
        }
      }
    },
    /**
     * 滚动事件
     * @param {*} e
     * @param {*} dom
     */
    onScroll(e, dom) {
      let scrollY = dom.scrollTop;
      if (Math.abs(this.scrollY - scrollY) > this.nodeHeight) {
        this.scrollY = scrollY;
        this.updateShowNodes();
      }
    },
    /**
     * 节点展开图标是否隐藏
     * @param {*} node
     * @returns
     */
    isExpandedOpacity(node) {
      if (this.lazy && !node.isLeaf) {
        return false;
      }
      if (node.childNodes?.length) {
        return false;
      }
      return true;
    },
    /**
     * 更新最大高度
     */
    updateMaxHeight() {
      // console.time("计算最大高度");
      const { filterNodeData, nodeData, nodeHeight } = this;
      let cloneNodeData = [...(filterNodeData || nodeData || [])];
      let maxHeight = 0;
      let expandNodeIds = [];
      while (cloneNodeData.length) {
        let cloneNode = cloneNodeData.shift();
        let node = this.getNode(cloneNode);
        if (!node) continue;
        if (node.expanded && cloneNode?.childNodes?.length) {
          cloneNodeData.unshift(...cloneNode.childNodes);
        }
        node.top = maxHeight;
        node.style = {
          "padding-left": (node.level - 1) * this.levelIndentWidth + "px",
          height: nodeHeight + "px",
          "line-height": nodeHeight + "px",
          top: node.top + "px"
        };
        expandNodeIds.push(node.id);
        maxHeight += nodeHeight;
      }
      this.maxHeight = maxHeight;
      this.expandNodeIds = expandNodeIds;
      // console.log(expandNodeIds.length);
      // console.timeEnd("计算最大高度");
      this.updateShowNodes();
    },
    /**
     * 更新显示的节点
     * @returns
     */
    updateShowNodes() {
      const { expandNodeIds, nodeHeight, showHeight, scrollY } = this;
      if (!expandNodeIds?.length || !showHeight) return (this.showNodes = []);
      let strt = Math.floor(scrollY / nodeHeight) - 2;
      if (strt < 0) strt = 0;
      let end = strt + Math.ceil(showHeight / nodeHeight) + 4;
      this.showNodes = expandNodeIds.slice(strt, end).map((id) => this.nodeMap[id]);
    },
    /**
     * 创建节点id
     * @returns
     */
    createTreeNodeId() {
      if (dsf.isUnDef(this.$maxTreeNodeId)) {
        this.$maxTreeNodeId = 0;
      } else {
        this.$maxTreeNodeId++;
      }
      return this.$maxTreeNodeId;
    },
    /**
     * 更新显示的高度
     */
    updateShowHeight() {
      this.showHeight = this.$el.clientHeight;
      this.updateMaxHeight();
    },
    /**
     * 通过节点获取key
     * @param {*} node
     */
    getNodeKey(node) {
      return node?.data?.[this?.nodeKey];
    },
    /**
     * 通过节点获取key
     * @param {*} node
     */
    getNodeDataKey(data) {
      return data?.[this?.nodeKey];
    },
    /**
     * 根据 data 或者 key 拿到 Tree 组件中的 node
     * @param {*} t
     * @param {Boolean} multiple 返回结构可能是数组
     */
    getNode(t, multiple) {
      if (this.isTreeNode(t)) {
        return this.nodeMap[t.id];
      } else if (this.isTreeNodeData(t)) {
        return this.nodeMap[t.$treeNodeId];
      } else if (this.existNodeKey && this.nodeDataMap && dsf.isString(t)) {
        let nodes = this.nodeDataMap[t];
        if (multiple && dsf.isArray(nodes)) {
          return nodes;
        } else {
          return dsf.isArray(nodes) ? nodes?.[0] : nodes;
        }
      }
      return null;
    },
    // 是否是树节点
    isTreeNode(t) {
      return dsf.isObject(t) && !dsf.isUnDef(t?.isTreeNode);
    },
    // 是否是树节点data
    isTreeNodeData(t) {
      return dsf.isObject(t) && !dsf.isUnDef(t?.$treeNodeId);
    },
    /**
     * 为 Tree 中的一个节点追加一个子节点
     * @param {*} data 节点的data
     * @param {*} pData 子节点的 parent 的 data、key 或者 node
     */
    append(data, pData) {
      let pNode = pData ? this.getNode(pData) : this.nodeTree;
      if (!pNode || !data) return;
      let datas = data;
      if (!dsf.isArray(datas)) datas = [datas];
      let isReset;
      datas.forEach((data) => {
        if (!dsf.isObject(data)) return;
        let appendData;
        if (this.isTreeNode(data) || this.isTreeNodeData(data)) {
          appendData = this.remove(data);
        } else {
          appendData = [data];
        }
        if (!appendData?.length) return;
        let childData = null;
        if (pNode?.data) {
          if (pNode.data?.[this.childrenKey]) {
            childData = pNode.data[this.childrenKey];
          } else {
            pNode.data[this.childrenKey] = [];
            childData = pNode.data[this.childrenKey];
          }
          pNode.expanded = true;
        } else {
          childData = this.data;
        }
        childData.push(...appendData);
        isReset = true;
      });
      isReset && this.resetBuildDataNodes();
    },
    /**
     * 为 Tree 的一个节点的前面增加一个节点
     */
    insertBefore(data, refData) {
      let refNode = this.getNode(refData);
      if (!refNode || !data) return;
      let datas = data;
      if (!dsf.isArray(datas)) datas = [datas];
      let isReset;
      datas.forEach((data) => {
        if (!dsf.isObject(data)) return;
        let insertData;
        if (this.isTreeNode(data) || this.isTreeNodeData(data)) {
          insertData = this.remove(data);
        } else {
          insertData = [data];
        }
        if (!insertData?.length) return;
        let pNode = refNode.parent;
        let childData;
        if (!pNode) {
          childData = this.data;
        } else {
          childData = pNode.data[this.childrenKey];
        }
        let index = childData.findIndex((t) => t.$treeNodeId == refNode.data.$treeNodeId);
        if (index >= 0) {
          if (index < 0) index = 0;
          childData.splice(index, 0, ...insertData);
          isReset = true;
        }
      });
      isReset && this.resetBuildDataNodes();
    },
    /**
     * 为 Tree 的一个节点的后面增加一个节点
     */
    insertAfter(data, refData) {
      let refNode = this.getNode(refData);
      if (!refNode || !data || (!dsf.isObject(data) && !dsf.isArray(data))) return;
      let datas = data;
      if (!dsf.isArray(datas)) datas = [datas];
      let isReset;
      datas.forEach((data) => {
        if (!dsf.isObject(data)) return;
        let insertData;
        if (this.isTreeNode(data) || this.isTreeNodeData(data)) {
          insertData = this.remove(data);
        } else {
          insertData = [data];
        }
        if (!insertData?.length) return;
        let pNode = refNode.parent;
        let childData;
        if (!pNode) {
          childData = this.data;
        } else {
          childData = pNode.data[this.childrenKey];
        }
        let index = childData.findIndex((t) => t.$treeNodeId == refNode.data.$treeNodeId);
        if (index >= 0) {
          childData.splice(index + 1, 0, ...insertData);
          isReset = true;
        }
      });
      isReset && this.resetBuildDataNodes();
    },
    /**
     * 删除 Tree 中的一个节点，使用此方法必须设置 node-key 属性
     * @param {*} data 要删除的节点的 data 或者 node
     */
    remove(data) {
      if (!this.existNodeKey || !data) return;
      let datas = data;
      if (!dsf.isArray(datas)) datas = [datas];
      let isReset;
      let removeData = [];
      let removeOldParentNode = [];
      datas.forEach((data) => {
        let node = this.getNode(data);
        if (!node) return;
        let childData = [];
        if (node?.parent?.data) {
          childData = node.parent.data?.[this.childrenKey];
        } else {
          childData = this.data;
        }
        let index = childData.findIndex((n) => n.$treeNodeId == node?.data?.$treeNodeId);
        if (index >= 0) {
          let data = childData.splice(index, 1)[0];
          removeData.push(data);
          let parentNode = this.getNode(data);
          parentNode?.parent && removeOldParentNode.push(parentNode.parent);
          isReset = true;
        }
      });
      removeOldParentNode.length &&
        this.$once("loadDataSuccess", () => {
          removeOldParentNode.forEach((pNode) => {
            if (pNode) {
              this.updateParentCheckSatus(pNode);
            }
          });
        });
      isReset && this.resetBuildDataNodes();
      return removeData;
    },
    /**
     * 通过 keys 设置节点子元素，使用此方法必须设置 node-key 属性
     * @param {String} key
     * @param {Aray} data
     */
    updateKeyChildren(key, data) {
      let pNode = this.getNode(key);
      if (!pNode || !data) return;
      let datas = data;
      if (!dsf.isArray(datas)) datas = [datas];
      const pChildren = this.getNodeDataChildren(pNode);
      let isReset;
      datas.forEach((data) => {
        if (dsf.isObject(data)) {
          pChildren.push(data);
          isReset = true;
        }
      });
      isReset && this.resetBuildDataNodes();
    },
    /**
     * 获取节点的所有子节点
     * @param {*} node
     * @returns
     */
    getNodeDataChildren(node) {
      if (!node || !node?.data) return null;
      if (!node?.data?.[this.childrenKey]) node.data[this.childrenKey] = [];
      return node?.data?.[this.childrenKey];
    },
    /**
     * 加载数据
     * @param {*} node
     * @param {*} cb
     * @returns
     */
    loadData(node, cb) {
      if (!this.lazy || !dsf.isFunction(this.load)) return;
      if (node) {
        this.$set(node, "loading", true);
        this.$set(node, "loaded", false);
      }
      !node?.loaded &&
        this.load(node, (data, buildSuccess) => {
          buildSuccess && this.$once("loadDataSuccess", buildSuccess);
          cb && this.$once("loadDataSuccess", cb);
          if (node) {
            node.loaded = true;
            node.loading = false;
          }
          if (dsf.isArray(data)) {
            if (!node || node.isRoot) {
              this.data.splice(0, this.data.length, ...data);
            } else {
              if (node.data) {
                if (!node.data[this.childrenKey]) node.data[this.childrenKey] = [];
                node.data[this.childrenKey].push(...data);
                this.resetBuildDataNodes();
              }
            }
          }
        });
    },
    /**
     * 节点是否禁用
     * @param {*} node
     * @returns
     */
    isDisabledNode(node) {
      let disabledKey = this?.props?.disabled || "disabled";
      let disabled = false;
      if (dsf.isString(disabledKey)) {
        disabled = node?.data?.[disabledKey];
      } else if (dsf.isFunction(disabledKey)) {
        disabled = disabledKey(node?.data, node);
      }
      return disabled;
    },
    /**
     * 过滤字段
     * @param {*} text
     */
    filter(text) {
      this.filterText = text;
      if (this.filterType == "lazy") {
        this.filterNodeData = null;
        this.reloadData();
        return;
      }
      if (this.filterText) {
        if (dsf.isFunction(this.filterNodeMethod)) {
          this.filterNodeData = filterNodeData.call(this, this.nodeData);
          this.updateMaxHeight();
          return;
        }
      }
      this.filterNodeData = null;
      this.updateMaxHeight();
    },
    /**
     * 重构data
     */
    resetBuildDataNodes() {
      if (!this.throttleResetBuildDataNodes) {
        this.throttleResetBuildDataNodes = _.throttle(
          () => {
            createTreeData.call(this, this.data);
            this.updateMaxHeight();
            if (this?.defaultExpandNodeIdsLoop?.length) {
              while (this.defaultExpandNodeIdsLoop.length) {
                let id = this.defaultExpandNodeIdsLoop.shift();
                this.nodeMap[id] && this.expandNode(this.nodeMap[id], true);
              }
            }
            this.$emit("loadDataSuccess", this);
          },
          200,
          {
            leading: false,
            trailing: true
          }
        );
      }
      this.throttleResetBuildDataNodes();
    },
    /**
     * 获取当前节点的路径
     */
    getNodePath(node) {
      let path = [];
      node = this.getNode(node);
      while (node) {
        path.unshift(node.data);
        node = node.parent;
      }
      return path;
    },
    /**
     * 滚动定位到指定的节点
     * @param {*} node
     * @param {string|number} offsetY center 居中显示 | top 置顶显示 | bottom 置底显示 | 20 距顶部偏移20px | -20 距顶部偏移-20px
     * @returns
     * nodeScrollIntoView(key, 'top')
     * nodeScrollIntoView(key, 'center')
     * nodeScrollIntoView(key, 'bottom')
     * nodeScrollIntoView(key, 20)
     * nodeScrollIntoView(key, -20)
     */
    nodeScrollIntoView(node, offsetY = "center") {
      node = this.getNode(node);
      if (!node) return;
      let top = parseInt(node.style.top);
      if (
        !dsf.isNumber(top) &&
        !dsf.isNumber(offsetY) &&
        !["center", "top", "bottom"].includes(offsetY)
      )
        return;
      if (dsf.isNumber(offsetY)) {
        top = top - offsetY;
      } else if (offsetY == "center") {
        top = top - this.showHeight / 2 + this.nodeHeight;
      } else if (offsetY == "bottom") {
        top = top - (this.showHeight - this.nodeHeight);
      }
      this._expandNode(node, true, false);
      this.$refs?.virtualScroll?.scrollTo(null, top);
    },
    /**
     * 获取虚拟根节点
     * @returns
     */
    getRootNode() {
      if (!this.nodeTree) {
        this.nodeTree = createNode.call(this, {});
        objectSetenumerableKey(this.nodeTree, "label", "全部");
        this.nodeTree.data = {};
        this.nodeTree.data[this.childrenKey] = [];
        this.nodeTree.data[this.nodeKey] = "__root__";
        this.nodeTree.data[this.labelKey] = this.nodeTree.label;
        this.nodeTree.isRoot = true;
        this.nodeTree.level = 0;
      }
      return this.nodeTree;
    },
    reloadData() {
      if (this.lazy) {
        this.isInit = false;
        this.loadData(this.nodeTree, (tree) => {
          this.isInit = true;
        });
      }
    }
  },
  watch: {
    currentNodeKey: {
      immediate: true,
      handler(key) {
        this.setCurrentKey(key);
      }
    },
    data: {
      immediate: true,
      handler() {
        this.resetBuildDataNodes();
        this.isInit = true;
      }
    },
    defaultExpandedKeys: {
      handler(keys) {
        keys?.forEach((key) => {
          let node = this.getNode(key);
          node && this.expandNode(node, true);
        });
      }
    },
    defaultCheckedKeys: {
      handler(keys) {
        this.setCheckedKeys(keys);
      }
    }
  },
  created() {
    this.reloadData();
  },
  mounted() {
    this.__resizeObserver = new ResizeObserver(([entry]) => {
      this.updateShowHeight();
    });
    this.__resizeObserver.observe(this.$el);
  },
  beforeDestroy() {
    if (this.__resizeObserver) {
      this.__resizeObserver.disconnect();
    }
  }
};
const nodeEnumKeys = ["previousSibling", "nextSibling", "isTreeNode", "label"];

function createTreeData(datas) {
  // console.time("重构数据");
  let treeData = buildNodes.call(this, datas, this.nodeTree);
  // console.timeEnd("重构数据");

  // console.time("创建数据映射");
  let totalData = 0;
  const nodeMap = {
    [this.nodeTree.id]: this.nodeTree
  };
  const nodeDataMap = {
    [this.getNodeKey(this.nodeTree)]: this.nodeTree
  };

  dsf.deepForEach(
    treeData,
    (node) => {
      totalData++;
      let key = this.getNodeKey(node);
      let nodeData = nodeDataMap[key];
      if (!nodeData) {
        nodeData = node;
      } else if (!dsf.isArray(nodeData)) {
        nodeData = [nodeData, node];
      } else {
        nodeData.push(node);
      }
      nodeDataMap[key] = nodeData;
      nodeMap[node.id] = node;
    },
    {
      children: "childNodes"
    }
  );
  this.nodeTree.childNodes = treeData;
  this.nodeTree.data = {};
  this.nodeTree.data[this.childrenKey] = datas || [];
  this.nodeMap = nodeMap;
  this.nodeDataMap = nodeDataMap;
  this.totalData = totalData;

  // console.timeEnd("创建数据映射");

  return treeData;
}

function buildNodes(datas, pNode) {
  if (dsf.isObject(datas)) {
    datas = [datas];
  }
  let nodes = [];
  for (let i = 0; i < datas.length; i++) {
    let n = datas[i];
    let nChildren = n[this.childrenKey] || [];
    let node;
    if (this.nodeMap?.[n?.$treeNodeId]) {
      node = this.nodeMap[n.$treeNodeId];
      dsf.setObjAttr(node, "parent", pNode);
      node.level = !pNode ? 1 : pNode.level + 1;
    } else {
      node = createNode.call(this, n, pNode);
    }
    if (!this.checkStrictly && pNode && pNode.checked) {
      node.checked = pNode.checked;
    }
    if (nChildren?.length) {
      node.childNodes = buildNodes.call(this, nChildren, node);
      node.isLeaf = false;
      node.loaded = true;
    } else {
      node.childNodes = [];
    }
    if (this.lazy) {
      let isLeaf = false;
      if (node.loaded && !nChildren?.length) {
        isLeaf = true;
      } else {
        let isLeafKey = this?.props?.isLeaf || "leaf";
        if (dsf.isString(isLeafKey)) {
          if (node?.data?.[isLeafKey] !== undefined) {
            isLeaf = node?.data?.[isLeafKey];
          }
        } else if (dsf.isFunction(isLeafKey)) {
          isLeaf = isLeafKey(node?.data, node);
        }
      }
      if (isLeaf) {
        node.isLeaf = true;
        node.loaded = true;
      }
    } else if (!nChildren?.length) {
      node.isLeaf = true;
      node.loaded = true;
    }
    objectSetenumerableKey(node, "previousSibling", i ? nodes[i - 1] : null);
    if (i) objectSetenumerableKey(nodes[i - 1], "nextSibling", node);
    nodes.push(node);
  }
  if (nodes.length) objectSetenumerableKey(nodes[nodes.length - 1], "nextSibling", null);
  return nodes;
}

function createNode(data, pNode) {
  // console.time(data._id)
  let nodeId = this.createTreeNodeId();
  objectSetenumerableKey(data, "$treeNodeId", nodeId);
  const node = {
    id: nodeId,
    text: null,
    visible: true,
    checked: false,
    expanded: false,
    indeterminate: false,
    isCurrent: false,
    isLeaf: false,
    level: !pNode ? 1 : pNode.level + 1,
    loaded: false,
    loading: false,
    childNodes: [],
    data
  };
  let nodeKey = this.getNodeKey(node);
  if (nodeKey) {
    node.isCurrent = this.currentNodeKey === nodeKey;
    if (this?._defaultCheckedKeys?.has?.(nodeKey)) {
      node.checked = true;
    }
    let defaultExpandLevel = parseInt(this.defaultExpandLevel);
    if (this.defaultExpandAll || defaultExpandLevel > 1 || this?.defaultExpandedKeys?.length) {
      if (!this.defaultExpandNodeIdsLoop) {
        this.defaultExpandNodeIdsLoop = [];
      }
      // if (this.defaultExpandAll || node.level < defaultExpandLevel || this.defaultExpandedKeys.includes(nodeKey)) {
      if (
        this.defaultExpandAll ||
        node.level < defaultExpandLevel ||
        this._defaultExpandedKeys.has(nodeKey)
      ) {
        this.defaultExpandNodeIdsLoop.push(node.id);
      }
    }
  }
  dsf.setObjAttr(node, "parent", pNode);
  objectSetenumerableKey(node, "label", data[this.labelKey] || "");
  objectSetenumerableKey(node, "isTreeNode", true);
  objectSetenumerableKey(node, "loadData", (cb) => {
    this.loadData(node, cb);
  });
  objectSetenumerableKey(node, "remove", () => {
    this.remove(node);
  });
  objectSetenumerableKey(node, "setData", (data) => {
    if (node.parent?.data) {
      let childData = node.parent.data[this.childrenKey];
      let index = childData.findIndex((n) => n.$treeNodeId == node.data.$treeNodeId);
      if (index > -1) {
        childData.splice(index, 1, data);
        this.resetBuildDataNodes();
      }
    }
  });
  // console.time(data._id)
  return node;
}

function objectSetenumerableKey(obj, key, value) {
  if (!dsf.isObject(obj)) return;
  if (
    Object.getOwnPropertyDescriptor(obj, key) &&
    Object.getOwnPropertyDescriptor(obj, key).configurable
  ) {
    Object.defineProperty(obj, key, {
      value: value,
      writable: false,
      configurable: true,
      enumerable: false
    });
  } else {
    Object.defineProperty(obj, key, {
      value: value,
      writable: false,
      configurable: true,
      enumerable: false
    });
  }
}

function filterNodeData(nodeData) {
  let nodeList = [];
  if (!nodeData) return nodeList;
  nodeData?.forEach((node) => {
    let cloneNode = Object.assign({}, node);
    nodeEnumKeys.forEach((key) => {
      objectSetenumerableKey(cloneNode, key, node[key]);
    });
    cloneNode.childNodes = filterNodeData.call(this, node.childNodes);
    if (cloneNode.childNodes.length || this.filterNodeMethod(this.filterText, node.data, node)) {
      nodeList.push(cloneNode);
    }
  });
  return nodeList;
}

function getKey(prefix, id) {
  return `${prefix}-${id}`;
}

function createData(maxDeep, maxChildren, minNodesNumber, deep = 1, key = "") {
  let id = 0;
  return Array.from({ length: minNodesNumber })
    .fill(deep)
    .map(() => {
      const childrenNumber = deep === maxDeep ? 0 : Math.round(Math.random() * maxChildren);
      const nodeKey = getKey(key, ++id);
      return {
        id: nodeKey,
        label: nodeKey,
        children: childrenNumber
          ? createData(maxDeep, maxChildren, childrenNumber, deep + 1, nodeKey)
          : undefined
      };
    });
}
